import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ssoCorporateGroupId = '', ...params }) => {
  return await dponetAPI.get(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_organizations/`,
    { params },
  )
}

const create = async ({ ssoCorporateGroupId = '', organizationId = '' }) => {
  return await dponetAPI.post(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_organizations`,
    { organizationId: organizationId },
  )
}

const destroy = async ({
  ssoCorporateGroupId = '',
  ssoCorporateGroupOrganizationId = '',
}) => {
  return await dponetAPI.delete(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_organizations/${ssoCorporateGroupOrganizationId}`,
  )
}

const ssoCorporateGroupOrganizations = {
  get,
  create,
  destroy,
}

export default ssoCorporateGroupOrganizations
